import { AppBar, Box, Button, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, Tab, Tabs, TextField, Typography, useMediaQuery } from '@mui/material'
import { Stack } from '@mui/system'
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useAddAddressMutation, useDeleteAddressMutation, useGetUserAddressesQuery, useGetUserOrdersQuery, useGetUserQuery, useUpdateAddressMutation, useUpdateUserMutation } from '../../features/fullApi'
import './user.css'
import { updateCurrentUser } from '../../features/slices/authSlice';
import Error403 from '../ErrorPages/Error403';
import { useTheme } from '@emotion/react'
import ClipLoader from 'react-spinners/ClipLoader'
import Container from '@mui/material/Container';
import EditIcon from '@mui/icons-material/Edit';
import EditEmailDialog from './EditAccount/EditEmailDialog'
import { toast } from 'react-hot-toast'
import EditUsernameDialog from './EditAccount/EditUsernameDialog'
import { useChangeEmailMutation, useChangePasswordMutation, useForgotPasswordMutation } from '../../features/authApi'
import PropTypes from 'prop-types';
import Address from './Address'
import { Country, State, City }  from 'country-state-city';
import PaginationComp from '../ProductsPages/Pagination/PaginationComp'
import CreateAddressDialog from '../Modals/CreateAddressDialog'
import FilterFramesIcon from '@mui/icons-material/FilterFrames';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import EditPasswordDialog from './EditAccount/EditPasswordDialog'

const EditUser = () => {
  window.scrollTo(0, 0);
  const params = useParams()
  const [updateUser] = useUpdateUserMutation()
  const dispatch = useDispatch()


  const [valueTab, setValueTab] = useState(params.tab === "orders" ? 2 : params.tab === "addresses" ? 1 : 0);

  const {data, error, isLoading} = useGetUserQuery({id: params.id});
  let user = useSelector(state => state.auth.user)
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
  }

  const [changeEmail] = useChangeEmailMutation();
  const [changePassword] = useChangePasswordMutation();
  const [forgotPassword] = useForgotPasswordMutation();
  const {data:userAddresses, error:errorUserAddresses, isLoading:isLoadingUserAddresses} = useGetUserAddressesQuery({id: params.id});

  const theme = useTheme()

  useEffect(() => {
    setValueTab(params.tab === "orders" ? 2 : params.tab === "addresses" ? 1 : 0)
  }, [params.tab])


  useEffect(() => {
    userAddresses?.map((address, index) => {
      if(index === 0) {
        values.name = userAddresses[0].name
        values.surname = userAddresses[0].surname
        values.city = userAddresses[0].city
        setCountry(userAddresses[0].country)
        values.street = userAddresses[0].street
        values.zipcode = userAddresses[0].zipcode
      }
    })
  }, [isLoadingUserAddresses])

 
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const [openCreateAddress, setOpenCreateAddress] = useState(false)

  const openCreateAddressModal = () => {
    setOpenCreateAddress(true)
  }


  const handleCreateAddress = ((data) => {
    setOpenCreateAddress(false)
    addAddress({name: data.name, userId: user._id, surname: data.surname, city: data.city, country:data.country, state: data.state, street: data.street, zipcode:data.zipcode, countryCode:data.countryCode}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    }).then({
      
    }
    )
  })
  
  const [openEmailModal, setOpenEmailModal] = useState(false)
  const [openPasswordModal, setOpenPasswordModal] = useState(false)
  const [openUsernameModal, setOpenUsernameModal] = useState(false)

  const openEmailModalFunc = () => {
    setOpenEmailModal(true)
    console.log("open email modal value", openEmailModal)
  }

  const openPasswordModalFunc = () => {
    setOpenPasswordModal(true)
    console.log("open Password modal value", openPasswordModal)
  }

  const openUsernameModalFunc = () => {
    setOpenUsernameModal(true)
    console.log("open username modal value", openUsernameModal)
  }

  const [updateAddress] = useUpdateAddressMutation()

 
  const handleUpdateUser = ((userData) => {
    console.log("USER SENT IS", user)
    if(userData.username) {
      setOpenUsernameModal(false)
      updateUser({_id: userData.id, username: userData.username}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      }).then(res => {
          const obj = res.data
          let copyObj = {...obj}
          console.log("copy obj is", copyObj);
          copyObj.accessToken = user?.accessToken
          copyObj.username = res.data.username
          copyObj.email = user?.email
          dispatch(updateCurrentUser(copyObj))
          toast.success("username edited successfully")
        }
      )
    } else if(userData.email) {
      setOpenEmailModal(false)
      toast.success(`A confirmation link has been sent to ${userData.email}`)
      changeEmail({_id: userData.id, email: userData.email})
      .then(res => {
        console.log("res is", res)
        if(!res.error) {
          toast.success(`A confirmation link has been sent to ${userData.email}`)
        }
        else {
        }
      })
    } else if(userData.newPassword) {
      setOpenPasswordModal(false)
      changePassword({_id: userData.id, newPassword: userData.newPassword, oldPassword: userData.oldPassword})
      .then(res => {
        console.log("res is", res)
        if(!res.error) {
          toast.success("Password successfully updated")
        }
        else {
          toast.error(res.error.data.message)
        }
      })
    }
  })

  console.log("params are", params)
  const [country, setCountry] = useState("")
  const [state, setState] = useState("")
  const [city, setCity] = useState("")
  const [countryCode, setCountryCode] = useState("")
  const [openAddress, setOpenAddress] = useState(false)
  const {data:userOrders, error:errorUserOrders, isLoading:isLoadingUserOrders} = useGetUserOrdersQuery(params.id);
  console.log("user orders", userOrders)
  

  const countries = Country.getAllCountries()
  const allStates = State.getAllStates()

  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])

  const [saved, setSaved] = useState(false)

  const handleChangeCountry = (e) => {
    console.log("E ON COUNTRY", e)
    setCountry(e)
    setStates(State.getStatesOfCountry(e.isoCode))
    console.log("STATES", states)
    setCountryCode(e.isoCode)
    setCity("")
    // console.log("states are", states)
    // cities = City.getCitiesOfState("RO", "DJ")
    // console.log("cities", cities)
  }

  const handleChangeState = (e) => {
    console.log("E ON STATE", e)
    setState(e)
    setCities(City.getCitiesOfState(e.countryCode, e.isoCode))
    handleChangeCity(City.getCitiesOfState(e.countryCode, e.isoCode).filter(city => city.name === userAddresses[0].city)[0])
  }

  const handleChangeCity = (e) => {
    console.log("hcs", e)
    setCity(e)
  }


  const [addAddress] = useAddAddressMutation()
  const [currentTab, setCurrentTab] = useState(params.tab);

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: "",
      surname: "",
      city: "",
      street: "",
      zipcode: "",
      region: "",
      country: "",
      countryCode: "",
    },
  });

  const [flag, setFlag] = useState(true)


  if(!isLoading && flag && !error) {
    setFlag(false)
    const fields = ['username', 'email'];
    fields.forEach(field => setFieldValue(field, data[field], false));
  }

  const [view, setView] = useState(false)

  const switchView = () => {
    console.log("switched view", !view)
    if(!view) {
      console.log("on setting empty")
      values.name = ""
      values.surname = ""
      setCountry("")
      values.street = ""
      values.zipcode = ""
      values.city = ""
    }
    setView(!view)
  }

  const navigate = useNavigate()

  const productsPerPage = 7
  const [pageNumber, setPageNumber] = useState(0)
  const pagesVisited = pageNumber * productsPerPage
  let displayOrders;
  let pageCount;
  displayOrders = userOrders?.slice(pagesVisited, pagesVisited + productsPerPage)
  pageCount = Math.ceil(userOrders?.length / productsPerPage)

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };



  const handleSwitchTab = (event, newValue) => {
    console.log("new value", newValue)
    if(newValue+1 > userAddresses.length) {
      toast(`You have only saved ${userAddresses.length} addresses`)
    } else {
      values.name = userAddresses[newValue].name
      values.surname = userAddresses[newValue].surname
      setCountry(userAddresses[newValue].country)
      values.street = userAddresses[newValue].street
      values.zipcode = userAddresses[newValue].zipcode
      setCurrentTab(newValue);
    }
  };

  const [open, setOpen] = useState(false)

  const renderMobileAccount = () => (
    <div style={{marginTop:'120px'}}>
    {(!error && !isLoading && !isLoadingUserAddresses && !isLoadingUserOrders) ? 
    (
    <Container style={{display: 'flex', flexDirection:'column'}}>
    <Typography variant="h5" style={{textAlign:'center', padding:'20px'}}>My Account</Typography>
    <Box>
    <div>
      <Tabs
        orientation="horizontal"
        variant="scrollable"
        value={valueTab}
        onChange={handleChangeDesktop}
        aria-label="horizontal tabs example"
        sx={{borderRight: 1, borderColor: 'divider'}}
      >
        <Tab onClick={() => navigate(`/account/${user._id}/user`)} sx={{display:'flex', justifyContent:'space-around', alignItems:'center', width:'110px'}} icon={<PersonIcon />} iconPosition="start" />
        <Tab onClick={() => navigate(`/account/${user._id}/addresses`)} sx={{display:'flex', justifyContent:'space-around', alignItems:'center', width:'110px'}} icon={<HomeIcon />} iconPosition="start"/>
        <Tab onClick={() => navigate(`/account/${user._id}/orders`)} sx={{display:'flex', justifyContent:'space-around', alignItems:'center', width:'110px'}} icon={<FilterFramesIcon />} iconPosition="start"/>
      </Tabs>
    </div>
      <TabPanel value={valueTab} index={0}>
        <div style={{display:'flex', flexDirection:'column', justifyContent:'start'}}>
        <Typography variant="h5" style={{borderBottom:'1px solid #efefef'}}>Account details</Typography>
        <div style={{display:'flex', width:'300px', justifyContent:'space-between', flexDirection:'column', paddingTop:"30px"}}>
          <div>
          <Typography variant="h6">Username and email</Typography>
          <form autoComplete="off">
                <FormControl style={{marginBottom: '10px'}} fullWidth>
                  <TextField
                      id="username"
                      type="text"
                      margin="dense"
                      value={user?.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      label={user?.username ? "" : "username"}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="start">
                            {
                              <EditIcon color="primary" onClick={() => openUsernameModalFunc()}/>
                            }
                          </InputAdornment>
                        ),
                      }}
                    />
                </FormControl>
                <EditUsernameDialog openUsernameModal={openUsernameModal} setOpenUsernameModal={setOpenUsernameModal} handleUpdateUser={handleUpdateUser}>         
                </EditUsernameDialog>
                {errors.username && touched.username && (
                  <p className="error">{errors.username}</p>
                )}
                <FormControl style={{marginBottom: '20px'}} fullWidth>
                  <TextField
                    id="email"
                    type="text"
                    margin="dense"
                    value={user?.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={user?.email ? "" : "email"}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          {
                            <EditIcon color="primary" onClick={() => openEmailModalFunc()}/>
                          }
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <EditEmailDialog openEmailModal={openEmailModal} setOpenEmailModal={setOpenEmailModal} handleUpdateUser={handleUpdateUser}>         
                </EditEmailDialog>
                {errors.email && touched.email && (
                  <p className="error">{errors.email}</p>
                )}
          </form>
          </div>
          <div>
          <Typography variant="h6">Password</Typography>
          <form autoComplete="off">
                <FormControl style={{marginBottom: '10px'}} fullWidth>
                  <TextField
                    id="password"
                    type="text"
                    margin="dense"
                    value={"***************"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={"password"}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          {
                            <EditIcon color="primary" onClick={() => openPasswordModalFunc()}/>
                          }
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <EditPasswordDialog openPasswordModal={openPasswordModal} setOpenPasswordModal={setOpenPasswordModal} handleUpdateUser={handleUpdateUser}>         
                </EditPasswordDialog>
                {errors.password && touched.password && (
                  <p className="error">{errors.password}</p>
                )}
          </form>
          </div>
        </div>
 
        </div>

      </TabPanel>
      <TabPanel value={valueTab} index={1} style={{width:'100%'}}>
      {userAddresses.length > 0 &&
      <div>
        <div style={{marginBottom:'10px'}}>
          <Typography variant="h5" style={{borderBottom:'1px solid #efefef'}}>Billing Addresses</Typography>
          <div>
            <Button size="small" variant="contained" color="secondary" style={{width: '150px', marginTop:'10px'}}  onClick={() => 
              { 
                if(userAddresses.length === 4) {
                  toast("⚠️ You can save a maximum of 4 addresses")
                } else {
                  openCreateAddressModal()
                }
              }}>New Address</Button>
              <CreateAddressDialog openCreateAddress={openCreateAddress} handleCreateAddress={handleCreateAddress} setOpenCreateAddress={setOpenCreateAddress}>         
              </CreateAddressDialog>
          </div>
        </div>
        <Grid container rowSpacing={2} style={{width:'300px', paddingTop:'30px'}}>
          {userAddresses.map((address, index) => (
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Address address={address} setOpen={setOpen} open={open}/>
          </Grid>
          ))}
        
        </Grid>
      </div>
    }

    
    {userAddresses.length === 0 &&
        <div>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid #efefef'}}>
              <Typography variant="h5">Billing Addresses</Typography>
              <Button size="small" variant="contained" color="secondary" style={{width: '150px'}}  
              onClick={() => openCreateAddressModal()}>New Address</Button>
          </div>
        
          <p style={{color: '#EFA00B', fontWeight: 'bold', marginTop:'50px'}}>You have no addresses saved</p>
            <CreateAddressDialog openCreateAddress={openCreateAddress} handleCreateAddress={handleCreateAddress} setOpenCreateAddress={setOpenCreateAddress}>         
            </CreateAddressDialog>
        </div>
    }

      </TabPanel>
      <TabPanel value={valueTab} index={2} style={{width:'100%'}}>
      <Typography variant="h5" style={{borderBottom:'1px solid #efefef'}}>Orders</Typography>
      <div style={{paddingTop:'30px'}}>
        {displayOrders.length > 0 ?
          displayOrders.map(order => (
            <div style={{display:'flex', width:'300px', justifyContent:'space-around', border:'1px solid #eee', padding:'10px', borderRadius:'5px', margin:'10px 0'}}>
              <div style={{display:'flex', justifyContent:'space-between', width:'100%', alignItems:'center'}}>
                <div>
                  <p>Order no. {order._id}</p>
                  <p>Placed on {order.createdAt.substring(0, 10)} <span style={{color:'#AD343E', fontWeight:'bold'}}>|</span> Amount {order.amount}</p>
                  <p>Status {order.status}</p>
                  <Button variant="outlined" style={{width:'150px'}} onClick={() => navigate(`/order/${order._id}`)}>Order Details</Button>
                </div>
              </div>
            </div>
        ))
         : (
          <div>
              <p style={{color: '#EFA00B', fontWeight: 'bold'}}>You have no orders yet</p>
          </div>
        )
          
        }
        </div>
        {pageCount > 1 &&
          <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
        }
      </TabPanel>
     </Box>
    </Container>
  ) : (error ?
    (<div>
      <Error403></Error403>
    </div>) : (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    )
    )}
  </div>
  )

  const handleChangeDesktop = async (event, newValue) => {
    setValueTab(newValue)
  };

  const renderDesktopAccount = () => (
    <div style={{width: '1200px', margin: '122px auto 0px', minHeight:'100vh'}}>
    {(!error && !isLoading && !isLoadingUserAddresses && !isLoadingUserOrders) ? 
    (
    <Container style={{display: 'flex', marginTop: '100px'}}>
    <Box
      sx={{ flexGrow: 1, display: 'flex', height: 300, padding:0 }}
    >
    <div>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={valueTab}
        onChange={handleChangeDesktop}
        aria-label="Vertical tabs example"
        sx={{height:'216px',  borderRight: 1, borderColor: 'divider', marginTop:'57px'}}
      >
        <Tab label="Account" onClick={() => navigate(`/account/${user._id}/user`)} sx={{display:'flex', justifyContent:'space-around', alignItems:'center', width:'200px'}} icon={<PersonIcon />} iconPosition="start" />
        <Tab label="Addresses" onClick={() => navigate(`/account/${user._id}/addresses`)} sx={{display:'flex', justifyContent:'space-around', alignItems:'center', width:'200px'}} icon={<HomeIcon />} iconPosition="start"/>
        <Tab label="Orders" onClick={() => navigate(`/account/${user._id}/orders`)} sx={{display:'flex', justifyContent:'space-around', alignItems:'center', width:'200px'}} icon={<FilterFramesIcon />} iconPosition="start"/>
      </Tabs>
    </div>
      <TabPanel value={valueTab} index={0} style={{width:'100%'}}>
        <div style={{display:'flex', flexDirection:'column', justifyContent:'start'}}>
        <Typography variant="h5" style={{borderBottom:'1px solid #efefef'}}>Account details</Typography>
        <div style={{display:'flex', justifyContent:'space-between', paddingTop:"30px"}}>
          <div>
          <Typography variant="h6">Account details</Typography>
          <form autoComplete="off">
                <FormControl style={{marginBottom: '10px'}}>
                  <TextField
                      id="username"
                      type="text"
                      margin="dense"
                      value={user?.username}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      label={user?.username ? "" : "username"}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="start">
                            {
                              <EditIcon color="primary" onClick={() => openUsernameModalFunc()}/>
                            }
                          </InputAdornment>
                        ),
                      }}
                    />
                </FormControl>
                <EditUsernameDialog openUsernameModal={openUsernameModal} setOpenUsernameModal={setOpenUsernameModal} handleUpdateUser={handleUpdateUser}>         
                </EditUsernameDialog>
                {errors.username && touched.username && (
                  <p className="error">{errors.username}</p>
                )}
                <FormControl style={{marginBottom: '10px'}}>
                  <TextField
                    id="email"
                    type="text"
                    margin="dense"
                    value={user?.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={user?.email ? "" : "email"}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          {
                            <EditIcon color="primary" onClick={() => openEmailModalFunc()}/>
                          }
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <EditEmailDialog openEmailModal={openEmailModal} setOpenEmailModal={setOpenEmailModal} handleUpdateUser={handleUpdateUser}>         
                </EditEmailDialog>
                {errors.email && touched.email && (
                  <p className="error">{errors.email}</p>
                )}
          </form>
          </div>
          <div>
          <Typography variant="h6">Your password</Typography>
          <form autoComplete="off">
                <FormControl style={{marginBottom: '10px'}}>
                  <TextField
                    id="password"
                    type="text"
                    margin="dense"
                    value={"***************"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label={"password"}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          {
                            <EditIcon color="primary" onClick={() => openPasswordModalFunc()}/>
                          }
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <EditPasswordDialog openPasswordModal={openPasswordModal} setOpenPasswordModal={setOpenPasswordModal} handleUpdateUser={handleUpdateUser}>         
                </EditPasswordDialog>
                {errors.password && touched.password && (
                  <p className="error">{errors.password}</p>
                )}
          </form>
          </div>
        </div>
 
        </div>

      </TabPanel>
      <TabPanel value={valueTab} index={1} style={{width:'100%'}}>
      {userAddresses.length > 0 &&
      <div>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', borderBottom:'1px solid #efefef', marginBottom:'10px'}}>
          <Typography variant="h5" style={{borderBottom:'1px solid #efefef'}}>Billing Addresses</Typography>
          <div style={{display: 'flex'}}>
            <Button size="small" variant="contained" color="secondary" style={{width: '150px'}}  onClick={() => 
              { 
                if(userAddresses.length === 4) {
                  toast("⚠️ You can save a maximum of 4 addresses")
                } else {
                  openCreateAddressModal()
                }
              }}>New Address</Button>
              <CreateAddressDialog openCreateAddress={openCreateAddress} handleCreateAddress={handleCreateAddress} setOpenCreateAddress={setOpenCreateAddress}>         
              </CreateAddressDialog>
          </div>
        </div>
        <div style={{display:'grid', paddingTop:"30px", gridTemplateColumns:'350px 350px', columnGap:'68px', rowGap:'30px'}}>
          {userAddresses.map((address, index) => (
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <Address address={address} setOpen={setOpen} open={open}/>
          </Grid>
          ))}
        
        </div>
      </div>
    }

    
    {userAddresses.length === 0 &&
        <div>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid #efefef'}}>
              <Typography variant="h5">Billing Addresses</Typography>
              <Button size="small" variant="contained" color="secondary" style={{width: '150px'}}  
              onClick={() => openCreateAddressModal()}>New Address</Button>
          </div>
        
          <p style={{color: '#EFA00B', fontWeight: 'bold', marginTop:'50px'}}>You have no addresses saved</p>
            <CreateAddressDialog openCreateAddress={openCreateAddress} handleCreateAddress={handleCreateAddress} setOpenCreateAddress={setOpenCreateAddress}>         
            </CreateAddressDialog>
        </div>
    }

      </TabPanel>
      <TabPanel value={valueTab} index={2} style={{width:'100%'}}>
      <Typography variant="h5" style={{borderBottom:'1px solid #efefef'}}>Orders</Typography>
      <div style={{paddingTop:'30px'}}>
        {displayOrders.length > 0 ?
          displayOrders.map(order => (
            <div style={{display:'flex', justifyContent:'space-around', border:'1px solid #eee', padding:'10px', borderRadius:'5px', margin:'10px 0'}}>
              <div style={{display:'flex', justifyContent:'space-between', width:'100%', alignItems:'center'}}>
                <div>
                  <p>Order no. {order._id}</p>
                  <p>Placed on {order.createdAt.substring(0, 10)} <span style={{color:'#AD343E', fontWeight:'bold'}}>|</span> Amount {order.amount}</p>
                  <p>Status {order.status}</p>
                </div>
                <Button variant="outlined" style={{width:'150px'}} onClick={() => navigate(`/order/${order._id}`)}>Order Details</Button>
              </div>
            </div>
        ))
         : (
          <div>
              <p style={{color: '#EFA00B', fontWeight: 'bold'}}>You have no orders yet</p>
          </div>
        )
          
        }
        </div>
        {pageCount > 1 &&
          <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
        }
      </TabPanel>
     </Box>
    </Container>
  ) : (error ?
    (<div>
      <Error403></Error403>
    </div>) : (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    )
    )}
  </div>
  )


  const renderTabletAccount = () => (
    <div>
    {(!error && !isLoading) ? (
    <Container style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center'}}>
    <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
      {(data?._id === params.id) && <Button element={Link} variant="contained" style={{width: '200px'}} onClick={() => navigate(`/orders/find/${data._id}`)}>See orders</Button>}
      <div>
        <form onSubmit={handleSubmit} autoComplete="off" id="editUserForm" >
          <div style={{width: '100%'}}>
            <h1 style={{textAlign: 'center'}}>Edit Credentials</h1>
          </div>
         
            <TextField
                id="username"
                type="text"
                margin="dense"
                value={values?.username}
                onChange={handleChange}
                onBlur={handleBlur}
                label={values?.username ? "" : "username"}
              />
              {errors.username && touched.username && (
                <p className="error">{errors.username}</p>
              )}

              <TextField
                id="email"
                type="text"
                margin="dense"
                value={values?.email}
                onChange={handleChange}
                onBlur={handleBlur}
                label={values?.email ? "" : "email"}
              />
              {errors.email && touched.email && (
                <p className="error">{errors.email}</p>
              )}

              <div className="btnContainer" style={{width: '100%'}}>
                <Stack direction="row" spacing={2} style={{textAlign: 'center'}}>
                  <Button variant="contained" color="primary" id="submitBtn" type="submit" style={{width: '200px'}}>
                    Update
                  </Button>
                </Stack>
              </div>
        </form>
      </div>
    </div>
    <div>
    <form onSubmit={handleSubmit} action="/upload" encType="multipart/form-data" autoComplete="off" id="registerForm">
      <h1 className="center">Billing Address</h1>
      <TextField
        id="name"
        type="text"
        value={values.name}    
        onChange={handleChange}
        onBlur={handleBlur}
        label="name"
        margin="dense"
      />
      {errors.name && touched.name && <p className="error">{errors.name}</p>}

      <TextField
        id="surname"
        type="text"
        margin="dense"
        onChange={handleChange}
        onBlur={handleBlur}
        label="surname"
      />
      {errors.surname && touched.surname && (
        <p className="error">{errors.surname}</p>
      )}

    <TextField
        id="city"
        type="text"
        margin="dense"
        onChange={handleChange}
        onBlur={handleBlur}
        label="city"
      />
      {errors.city && touched.city && (
        <p className="error">{errors.city}</p>
      )}

    <TextField
        id="street"
        type="text"
        margin="dense"
        onChange={handleChange}
        onBlur={handleBlur}
        label="street"
      />
      {errors.street && touched.street && (
        <p className="error">{errors.street}</p>
      )}

    <TextField
        id="zipcode"
        type="number"
        margin="dense"
        onChange={handleChange}
        onBlur={handleBlur}
        label="zipcode"
      />
      {errors.zipcode && touched.zipcode && (
        <p className="error">{errors.zipcode}</p>
      )}


    <TextField
        id="countryCode"
        type="text"
        margin="dense"
        onChange={handleChange}
        onBlur={handleBlur}
        label="Country Code"
      />
      {errors.countryCode && touched.countryCode && (
        <p className="error">{errors.countryCode}</p>
      )}
    </form>
    </div>
    </Container>
    ) : (error ?
    (<div>
      <Error403></Error403>
    </div>) : (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    )
    )
  }
  </div>
  )
   


  return (
    <div>
        {
        (isXs) ?  renderMobileAccount() : 
        (isSm) ? renderMobileAccount() :
        (isMd) ? renderTabletAccount() :
        renderDesktopAccount()
      }
    </div>
  )


}

export default EditUser